import type { IsoDate } from './iso-date';
import { toUtcMs } from './to-utc-ms';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export function isIsoDate(value: unknown): value is IsoDate {
  return typeof value === 'string' && ISO_DATE.test(value) && !Number.isNaN(toUtcMs(value));
}
